var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-radio-group',{attrs:{"size":_vm.size},on:{"change":_vm.onSelectChanged},model:{value:(_vm.unitProp),callback:function ($$v) {_vm.unitProp=$$v},expression:"unitProp"}},[_c('el-radio-button',{attrs:{"label":"stdUnit"}},[_vm._v("原始单位")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"displayUnit"}},[_vm._v("常用单位")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-403466c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Data/UnitSwitch.vue
// module id = null
// module chunks = 